<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="100px"
          >
            <el-form-item label="核对结果" prop="code" label-width="120px">
              <el-input
                class="form-input"
                v-model="searchForm.code"
                size="small"
                clearable
                placeholder="请输入编码"
              ></el-input>
            </el-form-item>
            <el-form-item label="查询时间" prop="updatedTime" label-width="80px">
              <el-date-picker
                class="date-input"
                size="small"
                v-model="searchForm.updatedTime"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="-"
                start-placeholder="起始时间"
                end-placeholder="截至时间">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column
            prop="code"
            label="序号"
            align="center"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="核对时间"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="customer"
            label="核对方式"
            width="160"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createNum"
            label="核对总经销商数"
            align="center"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="activityJoinNum"
            label="异常经销商数"
            align="center"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="pullNew"
            label="核对结果"
            align="center"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="joinNum"
            label="核对人"
            align="center"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="joinNum"
            label="核对人"
            align="center"
            width="160"
          ></el-table-column>
          <el-table-column
            label="操作"
            class-name="action-column"
            align="center"
          >
            <template v-slot="scope">
              <el-button
                type="text"
                size="small"
                @click="handleAdd(scope.row, 3)"
              >
                下载异常数据
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        code: "",
        name: "",
        parentIdCode: "",
        updatedTime: [],
      },
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
    };
  },
  methods: {
    init() {
      this.getList();
      this.getOrgBoardInfo()
    },
    getOrgBoardInfo() {
      this.$api.dataReport.orgBoardInfo()
      .then( res => {
        this.panelData = res.data
      })
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport.orgDateReportPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
          this.filterParam.startTime = val[0] || "";
          this.filterParam.endTime = val[1] || "";
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          name: "manageList",
          params: row,
        });
      }else if(actionType == 1) {
        let params = {
          ...this.filterParam
        };
          this.$api.common.doExport('orgDateReportPageList', params).then(() => {
            this.$message.success('导出操作成功，请前往导出记录查看详情');
        });
      }
    }
  },
  filters: {},
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .date-input  {
    width 220px !important
  }
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
      text-align: center;
      padding: 6px 0;
    }
  }
}
</style>
